import { render, staticRenderFns } from "./FavElement.vue?vue&type=template&id=d09a7f8c&"
import script from "./FavElement.vue?vue&type=script&lang=js&"
export * from "./FavElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d09a7f8c')) {
      api.createRecord('d09a7f8c', component.options)
    } else {
      api.reload('d09a7f8c', component.options)
    }
    module.hot.accept("./FavElement.vue?vue&type=template&id=d09a7f8c&", function () {
      api.rerender('d09a7f8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-24CwhT4Hl8rws/JS/comp/FavElement.vue"
export default component.exports